import { createContext } from "react";

export interface LocaleContextType {
  locale: string | undefined;
  setLocale: (_locale: string) => void;
}

export const LocaleContext = createContext<LocaleContextType | undefined>(
  undefined,
);
